import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import withTranslations from '../../translations';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { logout } from '../../actions/authentication';
import { logoutUrl } from '../../constants/urls';

import {
  Button,
  Paper,
  Typography,
} from '../../components/base';

const styles = theme => ({
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  root: {
    height: '100vh',
  },
  paper: {
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(6)}px`,
    flexDirection: 'column',
    justifyContent: 'space-around',
    height: '80%',
    width: '90%',
    minHeight: 200,
    maxHeight: 350,
    textAlign: 'center',

    '&>div': {
      marginBottom: theme.spacing(3),
    },

    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing(4)}px ${theme.spacing(12)}px ${theme.spacing(8)}px`,
      maxWidth: 600,
    },
  },
  logoutButton: {
    color: theme.palette.primary.main,
  },
})

class AuthenticationErrorView extends Component {

  handleLogout = async () => {
    await this.props.actions.logout();
    window.location.href = logoutUrl()
  }

  render() {
    const { classes: c, gt } = this.props;

    return (
      <div className={classNames(c.root, c.flexCenter)}>
        <Paper className={classNames(c.paper, c.flexCenter)}>
          <Typography variant='h5'>{gt.Errors.authErrorTitle}</Typography>
          <div>
            <Typography variant='body1'>{gt.Errors.authErrorParagraph1}</Typography>
            <Typography variant='body1'>{gt.Errors.authErrorParagraph2}</Typography>
          </div>
          <Typography variant='body1'>{gt.Errors.authErrorParagraph3}</Typography>
          <Button
            className={c.logoutButton}
            onClick={this.handleLogout}
            variant='contained'
            color='secondary'
          >
            {gt.logout}
          </Button>
        </Paper>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    logout: bindActionCreators(logout, dispatch),
  }
});

export default withStyles(styles)(withTranslations(connect(null, mapDispatchToProps)(AuthenticationErrorView)))



// WEBPACK FOOTER //
// ./src/views/AuthenticationError/AuthenticationErrorView.js